<h3 class="ui primary header">
  {{ modal.context.isEdit ? "Edit" : "Add" }} {{ heading | titlecase }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<app-warning-label></app-warning-label>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <!-- <div class="ui basic segment" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex>
                  <svg width="72" height="68" viewBox="0 0 72 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="70" height="66" rx="5" stroke="#999999" stroke-width="2" stroke-dasharray="4 4"/>
                        <path d="M43 35H37V41H35V35H29V33H35V27H37V33H43V35Z" fill="black" fill-opacity="0.54"/>
                        </svg>
            </div>
            <div fxFlex="grow"><strong class="text">Upload Picture here</strong></div>
        </div> -->
    <form class="ui form" [formGroup]="documentForm" appMargin style="margin-bottom: 30px">
      <div fxLayout="row">
        <h2 class="ui head" fxFlex="auto">Upload Supporting Documents</h2>
        <button class="ui tiny icon button" fxLayoutAlign="end" style="border: none !important">
          <i class="ui plus icon hoverable" suiPopup [popupInverted]="true" popupPlacement="bottom"
            popupText="upload Document" (click)="createDocument()"></i>
        </button>
      </div>
      <div class="ui divider" appMargin marginT="1"></div>
      <div class="field" appMargin marginT="5px">
        <ng-container formArrayName="documents">
          <ng-container *ngFor="let docForm of documents.controls; let i = index">
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" appMargin marginB="15px">
              <div fxFlex="grow" class="ui segment" [formGroup]="docForm" style="border-radius: 8px">
                <div fxFlex="row" fxLayoutGap="10px" fxLayoutAlign="start center" (click)="uploader.click()">
                  <div fxFlex="50px" *ngIf="!fileNameArr[i]">
                    <div class="bordered-square"></div>
                  </div>
                  <div fxFlex="10" *ngIf="fileNameArr[i]">
                    <img src="assets/icons/file-type/doc-upload.svg" alt="" />
                  </div>
                  <div fxFlex="75">
                    <div>
                      {{ fileNameArr[i] ? fileNameArr[i] : "Upload Document
                      Here" }}
                      <!-- <sui-progress
                        class="tiny primary"
                        appMargin
                        marginB="0"
                        [value]="doc.progress"
                        *ngIf="doc.progress > 0"
                      >
                      </sui-progress> -->
                    </div>
                  </div>
                  <div fxFlex fxLayoutAlign="end">
                    <input #uploadDoc type="file" accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx" #uploader
                      (change)="onFileChange($event, i)" placeholder="Browse for documents" onclick="value = null"
                      style="display: none" />
                    <div class="ui button" *ngIf="!fileNameArr[i]"
                      style="background-color: #eaeffb; border-radius: 8px">
                      Browse
                    </div>
                    <img class="hoverable" src="assets/icons/cancel.svg" *ngIf="fileNameArr[i]"
                      (click)="removeDocSegment()" />
                  </div>
                </div>
              </div>
              <!-- <i
                fxFlex="10px"
                class="ui cancel icon hoverable"
                (click)="removeDocSegment()"
              ></i> -->
            </div>
          </ng-container></ng-container>
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: inherit; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Back
  </button>
  <button class="ui primary button" [ngClass]="{ yellow: pending }" [disabled]="pending" (click)="submit()" autofocus>
    Done
  </button>
</div>
